const DISMISSED_SYSTEM_BANNERS_KEY = 'dismissedSystemBannerIds';

// Storage can be unavailable (private mode, blocked site data), in which case dismissals last for the session only.
export const getDismissedSystemBannerIds = (): string[] => {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(DISMISSED_SYSTEM_BANNERS_KEY) ?? '[]');
    return Array.isArray(stored) ? stored.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export const saveDismissedSystemBannerIds = (ids: string[]) => {
  try {
    localStorage.setItem(DISMISSED_SYSTEM_BANNERS_KEY, JSON.stringify(ids));
  } catch {
    // Ignore: see getDismissedSystemBannerIds.
  }
};
